// Copyright 2022 - 2023 Fewcha. All rights reserved.

import { store } from "app/store";
import axios from "axios";

export const api = () => {
  const { config } = store.getState();
  return axios.create({ baseURL: config.base.BASE_URL });
};
